/*
 * decaffeinate suggestions:
 * DS002: Fix invalid constructor
 * DS102: Remove unnecessary code created because of implicit returns
 * DS206: Consider reworking classes to avoid initClass
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/main/docs/suggestions.md
 */
import React from 'react';
import PropTypes from 'prop-types';
import { ProgressBar } from '../progress_bar.jsx';
import { Dropzone } from '../dropzone.jsx';

// The "No Photo" display
//
// This also implements file selection and drop acceptance
export class NoPhoto extends React.Component {
  static propTypes = {
    imageSelected: PropTypes.func,
    uploading: PropTypes.bool,
    uploadProgress: PropTypes.number,
    statusMessage: PropTypes.string,
    showingEmpty: PropTypes.bool,
    onClose: PropTypes.func,
    allowChoose: PropTypes.bool,
    allowUpload: PropTypes.bool,
    dropzoneComponent: PropTypes.func
  };

  static defaultProps = {
    uploading: false,
    uploadProgress: 0,
    showingEmpty: false,
    allowChoose: true,
    allowUpload: true,
    dropzoneComponent: Dropzone
  };

        constructor(props) {
          super(props);
          this.uploadClicked = this.uploadClicked.bind(this);
          this.onFileChanged = this.onFileChanged.bind(this);
          this.imageSelected = this.imageSelected.bind(this);
          this.chooseClicked = this.chooseClicked.bind(this);
          this.closeClicked = this.closeClicked.bind(this);
          this._setFileInputRef = this._setFileInputRef.bind(this);

          this.state = {
            progressSupported: (!!window.ProgressEvent && !!window.FormData),
            dragActive: false
          };
        }

        // User click to open the file upload dialog
        uploadClicked(event) {
          if (this.file_input != null) {
            this.file_input.click();
          }
          return event.preventDefault();
        }

        // File selected in the file input
        onFileChanged(event) {
          if (event.target.files[0]) { this.imageSelected(event.target.files[0]); }
          return event.target.value = null;
        }

        // Image changed, either from drop or input select, so push it out
        imageSelected(file) {
          return (typeof this.props.imageSelected === 'function' ? this.props.imageSelected(file) : undefined);
        }

        chooseClicked(event) {
          event.preventDefault();
          return (typeof this.props.libraryOpened === 'function' ? this.props.libraryOpened(event) : undefined);
        }

        closeClicked(event) {
          event.preventDefault();
          return (typeof this.props.onClose === 'function' ? this.props.onClose(event) : undefined);
        }

        _setFileInputRef(element) { return this.file_input = element; }

        render() {
          let message;
          if (this.props.uploading) {
            if (this.state.progressSupported) {
              message = <div className="drop-target-text">
                <ProgressBar percent={this.props.uploadProgress}>
                  <p aria-live="polite">{this.props.uploadProgress < 100 ? `Uploading (${  this.props.uploadProgress  }%)...` : "Processing..."}</p>
                </ProgressBar>
              </div>;
            } else {
              message = <div className="drop-target-text">
                <ProgressBar percent={50}>
                  <p aria-live="polite">Uploading...</p>
                </ProgressBar>
              </div>;
            }
          } else if (this.props.showingEmpty) {
            message = <div className="drop-target-text">
              <span role="alert">Your recent photos are empty. Drag one here to add it.</span>
              {' '/* jsx collapses spaces */}
              <button className="btn btn-color" onClick={this.closeClicked}>Go Back</button>
            </div>;
          } else {
            message = <div className="drop-target-text">
              Drop <i className="fa fa-file-image" aria-label="image" /> here or
              {' '/* jsx collapses spaces */}
              <a href="#" onClick={this.uploadClicked} className="btn btn-color" aria-label="Upload Photo">Upload</a>
              {this.props.allowChoose && ' '/* jsx collapses spaces */}
              {this.props.allowChoose && <a href="#" onClick={this.chooseClicked} className="btn btn-color">Choose from Photo Library</a>}
            </div>;
          }

          const DropzoneComponent = this.props.dropzoneComponent;

          return <div className="no-photos">
            <input type="file"
                   ref={this._setFileInputRef}
                   onChange={this.onFileChanged}
                   style={{display: "none"}}
                   name="photo"
                   accept="images"/>

            <DropzoneComponent onDrop={this.imageSelected}
                               accept="image/*">
              {message}
            </DropzoneComponent>
          </div>;
        }
}
